import axios from "axios";
import Constant from "../../Constant";

// GET Header
export const getHeader = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/header`,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// GET Home
export const gethome = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/home`,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};
// GET Footer
export const getfooter = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/footer`,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// GET Assessment landing page
export const getRiskFallData = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/assesment-landing`,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// GET assessment page
export const getAssessmentData = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/assesment`,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// post score
export const getScoreValues = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/assesment-score`,
            data: payload,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// post kalvio address
export const postKalvioEmail = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/klaviyo-email`,
            data: { email: payload },
        });
        callback(response?.data);
    } catch (e) { callback("", e?.response) }
};



// post email address
export const postScoreList = async (callback, payload,view) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}${view === `score_page` ? `/v2` :``}/assesment-email`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) { callback("", e?.response) }
};

// post email address
export const getPDFEmailAddress = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/assesment-redirect`,
            data: payload,
        });
        callback(response?.data?.data);
    } catch (e) { callback("", e?.response) }
};

//post pdf download and newslater 
export const pdpfDownload = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/v2/assesment-email`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) { callback("", e?.response) }
};

// post bundle layout screen
export const postBundleLayout = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/floor-plan`,
            data: payload,
        });
        callback(response?.data?.data);
    } catch (e) { callback("", e?.response) }
};


// post bundle layout screen
export const postYourBundleList = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/bundles-list`,
        });
        callback(response?.data?.data);
    } catch (e) { callback("", e?.response) }
};

//bundle details
export const getBundleDetails = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/v2/bundles-details`,
            data: payload,
        });
        callback(response?.data?.data);
    } catch (e) { callback("", e?.response) }
};

//product details
export const getProductDetails = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/v2/product-detail`,
            data: payload,
        });
        callback(response?.data?.data);
    } catch (e) { callback("", e?.response) }
};

// post bundle layout screen
export const getIsipCodeValid = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/geolocation`,
            data: payload
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// post bundle layout screen
export const postProductAddedBundle = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/add-to-cart-bundle`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// post bundle layout screen
export const postSingleProductAdded = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/add-to-cart-single-product`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// post bundle layout screen
export const getCartList = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/v2/get-cart-products`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// checkout contact information
export const getContactInfo = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/checkout1`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// checkout shipping information
export const getShippingAddressInfo = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/checkout2`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response?.data)
    }
};
// checkout getOrderSummary orderinformation
export const getOrderSummary = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/order-summary`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// checkout payment initialization orderinformation
export const getPayentInitialization = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/initializing-payment`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

//country list
// GET assessment page
export const getCountryList = async (callback) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/country`,
        });
        callback(response?.data?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// checkout payment initialization orderinformation
export const getStateList = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/state`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// export const getStateList = async (callback, payload) => {
//     try {
//         // Make the GET request with payload passed as params
//         const response = await axios.get(`${Constant.baseUrl()}/state`, { params: payload });
//         // Invoke the callback with the response data
//         callback(response.data);
//     } catch (error) {
//         // Handle errors
//         callback("", error.response);
//     }
// };

// checkout getShippingMethod
export const getShippingMethod = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/shipping-method`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};



// checkout payment initialization orderinformation
export const getBillingStateList = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/billing-state`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response)
    }
};

// checkout payment initialization orderinformation
export const getPaymentStatus = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/validate`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response?.data)
    }
};

// checkout getPaymentSuccess
export const getPaymentSuccess = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/thankyou`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response?.data)
    }
};

// checkout shipping information
export const getBillingAddressInfo = async (callback, payload) => {
    try {
        const response = await axios({
            method: "post",
            url: `${Constant.baseUrl()}/billing-details`,
            data: payload,
        });
        callback(response?.data);
    } catch (e) {
        callback("", e?.response?.data)
    }
};